import { rgba } from 'polished';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Form = styled.form<{ margin?: string }>`
  width: 100%;
  &&& {
    div.ant-row.ant-form-item {
      flex-direction: column;
      div.ant-form-item-label {
        text-align: left;
        label {
          height: auto;
          &:before,
          &:after {
            margin-right: 0;
            content: '';
          }
          &:not(.ant-form-item-required):after {
            content: '(optional)';
            margin-left: 4px;
            color: ${rgba(COLOR.BLACK, 0.45)};
          }
        }
      }
    }
  }
`;
